import React from "react";
import { collection, query, where, doc, updateDoc, getDocs } from "firebase/firestore";
import { db } from "../Firebase/firebase";
import { UserAuth } from "../Firebase/authcontext";

export function FriendRequestModal(props) {
  const { user } = UserAuth();

  const acceptFriendRequest = async (uid) => {
    try {
      // Fetch current user's document
      const userProfileQuery = query(collection(db, "User"), where("uid", "==", user.uid));
      const userSnapshot = await getDocs(userProfileQuery);
  
      if (userSnapshot.empty) {
        console.error("Current user not found.");
        return;
      }
  
      const userDoc = userSnapshot.docs[0];
      const userDocId = userDoc.id;
  
      // Fetch friend's document
      const friendProfileQuery = query(collection(db, "User"), where("uid", "==", uid));
      const friendSnapshot = await getDocs(friendProfileQuery);
  
      if (friendSnapshot.empty) {
        console.error("Friend not found.");
        return;
      }
  
      const friendDoc = friendSnapshot.docs[0];
      const friendDocId = friendDoc.id;
  
      // Update friend's document
      const friendData = friendDoc.data();
      // console.log("Friend Data:", friendData); 
      // console.log("Incoming Request List:", friendData?.incomming_request_list); 
  
      const updatedFriendData = {
        ...friendData,
        incomming_request_list: (friendData?.incomming_request_list || []).filter((id) => id !== user.uid),
        friendId_list: [...(friendData?.friendId_list || []), user.uid],
      };
  
      await updateDoc(doc(db, "User", friendDocId), updatedFriendData);
      console.log("Updated friend's data:", updatedFriendData);
  
      // Update current user's document
      const userData = userDoc.data();
      console.log("User Data:", userData); 
      console.log("Incoming Request List:", (userData?.incoming_request).filter((id) => id !== uid));
      const updatedUserData = {
        ...userData,
        incoming_request: (userData?.incoming_request || []).filter((id) => id !== uid),
        friendId_list: [...(userData?.friendId_list || []), uid],
      };
  
      await updateDoc(doc(db, "User", userDocId), updatedUserData);
      // console.log("Updated user's data:", updatedUserData);
  
      // console.log("Friend request accepted successfully.");
    } catch (error) {
      console.error("Error accepting friend request:", error);
    }
  };
  
  

  return (
    <table
      style={{
        backgroundColor: "white",
        borderRadius: "20px",
        marginTop: "20px",
        width: "100%",
      }}
    >
      <tbody>
        <tr style={{ padding: "20px" }}>
          <td style={{ padding: "20px" }}>
            <img
              style={{ width: "50px", borderRadius: "50%" }}
              src={props.img}
              alt="User"
            />
          </td>
          <td style={{ padding: "20px" }}>
            <h6>{props.name}</h6>
            <h6>{props.position}</h6>
          </td>
          <td style={{ padding: "20px" }}>
              <button
                onClick={() => acceptFriendRequest(props.uid)}
                style={{
                  color: "#0070ff",
                  borderRadius: "5px",
                  border: "1px solid #0070ff",
                  padding: "5px 10px",
                }}
              >
                <b>Accept Request</b>
              </button>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
